import { gql } from "@apollo/client";

export const loginQuery = gql`
    mutation loginQuery($input: UsersPermissionsLoginInput) {
        login(input: $input) {
            jwt
            user {
                id
                username
            }
        }
    }
`;

export const createNewUserForLogin = gql`
    mutation CreateUser($input: UsersPermissionsRegisterInput!) {
        register(input: $input) {
            jwt
            user {
                id
                username
                email
            }
        }
    }
`;

export const deleteDocumentLink = gql`
mutation deleteDocumentLink ($id: ID!){
  	deleteDocumentLink(id: $id){
    data{
      id
    }
  }
}`;

export const deleteDocumentsProfessionalList = gql`
mutation deleteDocumentsProfessionalList($id: ID!) {
  deleteDocumentsProfessionalList(id: $id) {
    data {
      id
    }
  }
}`;

export const uploadNewDocument = gql`
    mutation Upload($file: Upload!) {
        upload(file: $file) {
            data {
                id
                attributes {
                    url
                }
            }
        }
    }
`;

//  // // // =======================================Staff mutations.............................................
export const createNewStaff = gql`
    mutation createStaffDetail(
        $first_name: String,
        $last_name: String,
        $email: String,
        $date_of_birth: Date,
        $ndis_clearance_number: String,
        $registration_expiry_date: Date,  
        $medicare_number: Long,
        $police_check: String,
        $do_you_have_driving_license: Boolean,
        $driving_license: Long,
        $user_type_id: String,
        $language_spoken: String,
        $religion: String,
        $age: String
    ){
        createStaffDetail(data:{
            first_name: $first_name,
            last_name: $last_name,
          	email: $email,
            date_of_birth: $date_of_birth,
            ndis_clearance_number: $ndis_clearance_number,
            registration_expiry_date: $registration_expiry_date,
            medicare_number: $medicare_number,
            police_check: $police_check,
            do_you_have_driving_license: $do_you_have_driving_license,
            driving_license: $driving_license,
          	user_type_id: $user_type_id,
            language_spoken: $language_spoken,
            religion: $religion,
            age: $age
        }){
            data{
                id
                attributes{
                    first_name
                    last_name
                    email
                }
            }
        }
    }
`;

export const createContactDetailForStaff = gql`
    mutation createContactDetail(
        $email: String,
        $home_phone: String,
        $mobile_phone: String,
        $work_phone: String,
        $address: String,
        $post_code: String,
        $staff_detail_id: ID
    ){
        createContactDetail(data:{
            email: $email,
            home_phone: $home_phone,
            mobile_phone: $mobile_phone,
            work_phone: $work_phone,
            address: $address,
            post_code: $post_code,
            staff_detail_id: $staff_detail_id
        }){
            data{
                id
                attributes{
                    email
                }
            }
        } 
    }
`;

export const createEmergencyContactDetailForStaff = gql`
    mutation createEmergencyContactDetail(
        $first_name: String,
        $last_name: String,
        $relationship: String,
        $email: String,
        $home_phone: String,
        $mobile_phone: String,
        $address: String,
        $staff_detail_id: ID
    ){
        createEmergencyContactDetail(data:{
            first_name: $first_name,
            last_name: $last_name,
            relationship: $relationship,
            email: $email,
            home_phone: $home_phone,
            mobile_phone: $mobile_phone,
            address: $address,
            staff_detail_id: $staff_detail_id
        }){
            data{
                id
                attributes{
                    first_name
                }
            }
        } 
    }
`;

export const createWorkingDay = gql`
    mutation createWorkingDay(
        $select_day: ENUM_WORKINGDAY_SELECT_DAY,
        $staff_detail_id: ID,
        $day_start_time: Time,
        $day_end_time: Time,
        $whole_day: Boolean,
        $unavailable: Boolean,
    ){
        createWorkingDay(data:{
            select_day: $select_day,
            staff_detail_id: $staff_detail_id,
            day_start_time: $day_start_time,
            day_end_time: $day_end_time,
            whole_day: $whole_day,
            unavailable: $unavailable,
        }){
            data{
                id
                attributes{
                    select_day
                }
            }
        } 
    }
`;

export const updateWorkingDay = gql`
  mutation updateWorkingDay($id: ID!,$data: WorkingDayInput!){
    updateWorkingDay(id: $id, data: $data){
      data{
        id
        attributes{
          whole_day
          unavailable        
        }
      }
    }
  }`;

export const deleteWorkingDay = gql`
  mutation deleteWorkingDay($id: ID!) {
  deleteWorkingDay(id: $id) {
    data {
      id
    }
  }
}`;

export const createDocumentsProfessionalList = gql`
    mutation createDocumentsProfessionalList(
        $module: String,        
        $type:String,
        $document_name: String,
        $staff_details_id: ID,
        $expiry_date: Date,
        $active: Boolean,
        $documents_description: String,
        $document_link: ID
    ){
        createDocumentsProfessionalList(data:{
            module: $module,
            type: $type,
            document_name: $document_name,
            staff_details_id: $staff_details_id,
            expiry_date: $expiry_date,
            active: $active,
            documents_description: $documents_description,
            document_link: $document_link
        }){
            data{
                id
                attributes{
                    document_link{
                        data{
                            id
                        }
                    }
                }
            }
        } 
    }
`;

export const createDocumentLink = gql`
mutation createDocumentLink(
  $file_name: String
  $file_type: String
  $file_url: String
  $staff_details_id: ID!
) {
  createDocumentLink(
    data: {
      file_name: $file_name
      file_type: $file_type
      file_url: $file_url
      staff_detail: $staff_details_id
    }
  ) {
    data {
      id
    }
  }
}

`;

export const createStaffOthersInformation = gql`
    mutation createStaffOthersInformation(
        $staff_details_id: ID,
        $staff_question_answer_refs: [ID]
    ){
        createStaffOthersInformation(data:{
            staff_details_id: $staff_details_id,
          	staff_question_answer_refs: $staff_question_answer_refs
        }){
            data{
                id
                attributes{
                    staff_question_answer_refs{
                        data{
                            id
                            attributes{
                                answer_type{
                                    ... on ComponentAnswersSingleAnswer{
                                        drop_down_option_lovs{
                                            data{
                                                id
                                                attributes{
                                                    title
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } 
    }
`;

export const createStaffPaymentDetail = gql`
    mutation createStaffPaymentDetail(
        $account_name: String,
        $account_number: String,
        $bsb_number: String,
        $superannuation_name: String,
        $member_number: String,
        $tax_file_number: String,
        $reason_notes: String,
        $staff_detail_id: ID,
  		$tax_free_threshold: Boolean
    ){
		createStaffPaymentDetail(data:{
            account_name: $account_name,
            account_number: $account_number,
            bsb_number: $bsb_number,
            superannuation_name: $superannuation_name,
            member_number: $member_number,
            tax_file_number: $tax_file_number,
            reason_notes: $reason_notes,
            staff_detail_id: $staff_detail_id,
      		tax_free_threshold: $tax_free_threshold
        }){
            data{
                id
                attributes{
                    account_name
                    account_number
                    bsb_number
                    superannuation_name
                    member_number
                    tax_file_number
                    reason_notes
                  	tax_free_threshold
                    staff_detail_id{
                        data{
                            id
                        }
                    }
                }
            }
        } 
    }
`;

export const updateStaffPaymentDetail = gql`
mutation updateStaffPaymentDetail($id: ID!, $data: StaffPaymentDetailInput!){
	updateStaffPaymentDetail(id: $id, data: $data){
		data{
			id			
		}
	}
}`;

export const createStaffAnswerLovsReference = gql`
    mutation createStaffAnswerLovsReference(
        $staff_detail_id: ID,
        $module: String,
        $module_Id: Int,
        $category: String,
        $input_name: String,
        $selected_option_value: String,
    ){
        createStaffAnswerLovsReference(data:{
            staff_detail_id: $staff_detail_id,
            module: $module,
            module_Id: $module_Id,
            category: $category,
            input_name: $input_name,
            selected_option_value: $selected_option_value
        }){
            data{
                id
                attributes{
                    staff_detail_id{
                        data{
                            id
                            attributes{
                                first_name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const updateStaffAnswerLovsReference = gql`
    mutation updateStaffAnswerLovsReference($id: ID!, $data: StaffAnswerLovsReferenceInput!){
        updateStaffAnswerLovsReference(id: $id, data: $data){
            data{
                id                
            }
        }
    }
`;

export const updateStaffQuestionAnswerRef = gql`
mutation updateStaffQuestionAnswerRef(
	$id: ID!
	$data: StaffQuestionAnswerRefInput!
) {
	updateStaffQuestionAnswerRef(id: $id, data: $data) {
		data {
			id
		}
	}
}

`;

export const createStaffQuestionSingleAnswerRef = gql`
    mutation createStaffQuestionAnswerRef(
        $staff_detail_id: ID,
        $module: String,
        $category: String,
        $question_title: String,
        $answer_type: [StaffQuestionAnswerRefAnswerTypeDynamicZoneInput!]
    ){
        createStaffQuestionAnswerRef(data:{
            staff_detail_id: $staff_detail_id,
            module: $module,
            category: $category,
            question_title: $question_title,
            answer_type: $answer_type
        }){
            data{
                id
                attributes{
                    staff_detail_id{
                        data{
                            id
                            attributes{
                                first_name
                            }
                        }
                    }
                }
            }
        }
    }
`;

// {
//     "answer_type": [
//         {
//             "__typename": "ComponentAnswersSingleAnswer",
//             "__component": "answers.single-answer",
//             "active": true,
//             "drop_down_option_lovs": 75
//         }
//     ]
// }


//  // // // =======================================Client mutations.............................................
export const createClientDetail = gql`
    mutation createClientDetail(
        $first_name: String,
        $last_name: String,
        $date_of_birth: Date,
        $age: Long,
        $ndis_number: String,
        $primary_diagnosis: String,
        $rankings: Int,
        $medicare_number: String,
        $medicare_expiry_date: Date,
        $centrelink_dva_number: String,
        $active: Boolean
    ){
        createClientDetail(data:{
            first_name: $first_name,
            last_name: $last_name,
            date_of_birth: $date_of_birth,
            age: $age,
            ndis_number: $ndis_number,
            primary_diagnosis: $primary_diagnosis,
            rankings: $rankings,
            medicare_number: $medicare_number,
            medicare_expiry_date: $medicare_expiry_date,
            centrelink_dva_number: $centrelink_dva_number,
            active: $active
        }){
            data{
                id
                attributes{
                    first_name
                }
            }
        }
    }
`;

export const createContactDetailForClient = gql`
    mutation createContactDetail(
        $email: String,
        $home_phone: String,
        $mobile_phone: String,
        $address: String,
        $post_code: String,
        $client_detail_id: ID
    ){
        createContactDetail(data:{
            email: $email,
            home_phone: $home_phone,
            mobile_phone: $mobile_phone,
            address: $address,
            post_code: $post_code,
            client_detail_id: $client_detail_id
        }){
            data{
                id
                attributes{
                    email
                }
            }
        } 
    }
`;

export const createEmergencyContactDetailForClient = gql`
    mutation createEmergencyContactDetail(
        $first_name: String,
        $last_name: String,
        $relationship: String,
        $email: String,
        $home_phone: String,
        $mobile_phone: String,
        $address: String,
        $client_detail_id: ID
    ){
        createEmergencyContactDetail(data:{
            first_name: $first_name,
            last_name: $last_name,
            relationship: $relationship,
            email: $email,
            home_phone: $home_phone,
            mobile_phone: $mobile_phone,
            address: $address,
            client_detail_id: $client_detail_id
        }){
            data{
                id
                attributes{
                    first_name
                }
            }
        } 
    }
`;

export const createCenterLinkHealthcare = gql`
    mutation createCenterLinkHealthcare(
        $medicare_number: String,
        $medicare_expiry_date: Date,
        $centrelink_dva_number: String,
        $client_id: ID,
    ){
        createCenterLinkHealthcare(data:{
            medicare_number: $medicare_number,
            medicare_expiry_date: $medicare_expiry_date,
            centrelink_dva_number: $centrelink_dva_number,
            client_id: $client_id,
        }){
            data{
                id
                attributes{
                    medicare_number
                    client_id{
                        data{
                            id
                        }
                    }
                }
            }
        } 
    }
`;

export const createAdministrativeNote = gql`
    mutation createAdministrativeNote(
        $general_notes: String,
        $client_detail_id: ID
    ){
        createAdministrativeNote(data:{
            general_notes: $general_notes,
            client_detail_id: $client_detail_id
        }){
            data{
                id
                attributes{
                    general_notes
                    client_detail_id{
                        data{
                            id
                        }
                    }
                }
            }
        } 
    }
`;

export const createServiceInformation = gql`
    mutation createServiceInformation(
        $client_detail_id: ID
        $respite_care: Boolean
        $community_participation: Boolean
        $supported_independent_living: Boolean
    ){
        createServiceInformation(data:{
            client_detail_id: $client_detail_id
            respite_care: $respite_care
            community_participation: $community_participation
            supported_independent_living: $supported_independent_living
        }){
            data{
                id
                attributes{
                    respite_care
                    community_participation
                    supported_independent_living
                }
            }
        }
    }
`;

export const createPreferenceForStaffWorker = gql`
    mutation createPreferenceForStaffWorker(
        $client_detail_id: ID,
        $active: Boolean,
        $age: Long,
        $gender: String,
        $language_spoken: String,
        $religion: String
    ){
        createPreferenceForStaffWorker(data:{
            client_detail_id: $client_detail_id,
            active: $active,
            age: $age,
            gender: $gender,
            language_spoken: $language_spoken,
            religion: $religion
        }){
            data{
                id
                attributes{
                    active
                    age
                }
            }
        }
    }
`;

export const createClientNote = gql`
    mutation createClientNote(
        $general_notes: String,
        $client_detail_id: ID,
    ){
        createClientNote(data:{
            general_notes: $general_notes,
            client_detail_id: $client_detail_id,
        }){
            data{
                id
                attributes{
                    general_notes
                }
            }
        } 
    }
`;

export const createClientGoal = gql`
    mutation createClientGoal(
        $goal: String,
        $client_detail_id: ID
        ){
        createClientGoal(data:{
            goal: $goal,
            client_detail_id: $client_detail_id
        }){
            data{
                id
                attributes{
                    goal
                }
            }   
        } 
    }
`;

export const createCheckListAlertsNotification = gql`
    mutation createCheckListAlertsNotification(
        $check_list_title: String,
        $check_list_comments: String,
        $client_detail_id: ID
    ){
        createCheckListAlertsNotification(data:{
            check_list_title: $check_list_title,
            check_list_comments: $check_list_comments,
            client_detail_id: $client_detail_id
        }){
            data{
                id
                attributes{
                    check_list_title
                    check_list_comments
                }
            }
        } 
    }
`;

export const createPlanReview = gql`
    mutation createPlanReview(
        $plan_start_date: Date,
        $plan_end_date: Date,
        $client_detail_id: ID
    ){
        createPlanReview(data:{
            plan_start_date: $plan_start_date,
            plan_end_date: $plan_end_date,
            client_detail_id: $client_detail_id,
        }){
            data{
                id
                attributes{
                    plan_start_date
                }
            }
        }
    }
`;

export const createPlanSupportCategory = gql`
    mutation createPlanSupportCategory(
        $budget: String,
        $date: Date,
        $client_detail_id: ID,
        $dynamic_support_category_id: ID,
        $plan_review_id: ID
    ){
        createPlanSupportCategory(data:{
            budget: $budget,
            date: $date,
            client_detail_id: $client_detail_id,
            dynamic_support_category_id: $dynamic_support_category_id,
            plan_review_id: $plan_review_id
        }){
            data{
                id
                attributes{
                    budget
                }
            }
        }
    }
`;

export const createClientAnswerLovsReference = gql`
    mutation createClientAnswerLovsReference(
        $client_detail_id: ID,
        $module: String,
        $module_Id: Int,
        $category: String,
        $input_name: String,
        $selected_option_value: String,
        ){
            createClientAnswerLovsReference(data:{
                client_detail_id: $client_detail_id,
                module: $module,
                module_Id: $module_Id,
                category: $category,
                input_name: $input_name,
                selected_option_value: $selected_option_value,
            }){
                data{
                id
                attributes{
                    client_detail_id{
                        data{
                            id
                            attributes{
                                first_name
                            }            
                        }
                    }
                }
            }
        }
    }
`;

export const updateClientAnswerLovsReference = gql`
    mutation updateClientAnswerLovsReference($id: ID!, $data: ClientAnswerLovsReferenceInput!){
        updateClientAnswerLovsReference(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateContactDetail = gql`
    mutation updateContactDetail($id: ID!, $data: ContactDetailInput!){
        updateContactDetail(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateReferringDoctorInformation = gql`
    mutation updateReferringDoctorInformation($id: ID!, $data: ReferringDoctorInformationInput!){
        updateReferringDoctorInformation(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateOnboardMedicalHistoryDetail = gql`
    mutation updateOnboardMedicalHistoryDetail($id: ID!, $data: OnboardMedicalHistoryDetailInput!){
        updateOnboardMedicalHistoryDetail(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateClientQuestionAnswerRef = gql`
    mutation updateClientQuestionAnswerRef($id: ID!, $data: ClientQuestionAnswerRefInput!){
        updateClientQuestionAnswerRef(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateMedicalInformation = gql`
    mutation updateMedicalInformation($id: ID!, $data: MedicalInformationInput!){
        updateMedicalInformation(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateEmergencyContactDetail = gql`
    mutation updateEmergencyContactDetail($id: ID!, $data: EmergencyContactDetailInput!){
        updateEmergencyContactDetail(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateAdministrativeNote = gql`
    mutation updateClientNote($id: ID!, $data: ClientNoteInput!){
        updateClientNote(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateServiceInformation = gql`
    mutation updateServiceInformation($id: ID!, $data: ServiceInformationInput!){
        updateServiceInformation(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updatePreferenceForStaffWorker = gql`
    mutation updatePreferenceForStaffWorker($id: ID!, $data: PreferenceForStaffWorkerInput!){
        updatePreferenceForStaffWorker(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateClientGoal = gql`
    mutation updateClientGoal($id: ID!, $data: ClientGoalInput!){
        updateClientGoal(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updateCheckListAlertsNotification = gql`
    mutation updateCheckListAlertsNotification($id: ID!, $data: CheckListAlertsNotificationInput!){
        updateCheckListAlertsNotification(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updatePlanReview = gql`
    mutation updatePlanReview($id: ID!, $data: PlanReviewInput!){
        updatePlanReview(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const updatePlanSupportCategory = gql`
    mutation updatePlanSupportCategory($id: ID!, $data: PlanSupportCategoryInput!){
        updatePlanSupportCategory(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const createMedicationsForClient = gql`
    mutation createMedicalInformation(
        $medication: String,
        $comments: String,
        $medication_time: Time,
        $client_detail_id: ID,
        $every_x_days_where_x_is: Int,
    ){
        createMedicalInformation(data:{
            medication: $medication,
            comments: $comments,
            medication_time: $medication_time,
            client_detail_id: $client_detail_id
            every_x_days_where_x_is: $every_x_days_where_x_is
        }){
            data{
                id
                attributes{
                    medication
                }
            }
        }
    }
`;

export const createOnboardMedicalHistoryDetail = gql`
    mutation createOnboardMedicalHistoryDetail(
        $client_detail_id: ID,
        $question_title: String,
        $answer_value: String
    ){
        createOnboardMedicalHistoryDetail(data:{
            client_detail_id: $client_detail_id,
            question_title: $question_title,
            answer_value: $answer_value
        }){
            data{
                id
                attributes{
                    question_title
                }
            }
        }
    }
`;

export const createReferringDoctorInformation = gql`
    mutation createReferringDoctorInformation(
        $client_detail_id: ID,
        $doctors_email: String,
        $referring_doctor: String,
        $referring_doctor_address: String,
        $referring_doctor_phone: String
        $medical_center: String
    ){
        createReferringDoctorInformation(data:{
            client_detail_id: $client_detail_id,
            doctors_email: $doctors_email,
            referring_doctor: $referring_doctor,
            referring_doctor_address: $referring_doctor_address,
            referring_doctor_phone: $referring_doctor_phone,
            medical_center: $medical_center
        }){
            data{
                id
                attributes{
                    doctors_email
                }
            }
        }
    }
`;

export const createAdmissionInformation = gql`
    mutation createAdmissionInformation(
        $client_detail_id: ID,
        $principal_diagnosis: String,
        $provisional_diagnosis: String,
        $identified_major_procedure: String
    ){
        createAdmissionInformation(data:{
            client_detail_id: $client_detail_id,
            principal_diagnosis: $principal_diagnosis,
            provisional_diagnosis: $provisional_diagnosis,
            identified_major_procedure: $identified_major_procedure
        }){
            data{
                id
                attributes{
                    principal_diagnosis
                }
            }
        }
    }
`;

export const createClientQuestionAnswerRef = gql`
    mutation createClientQuestionAnswerRef(
        $client_detail_id: ID,
        $module: String,
        $category: String,
        $question_title: String,
        $answer_type: [ClientQuestionAnswerRefAnswerTypeDynamicZoneInput!],
    ){
        createClientQuestionAnswerRef(data:{
            client_detail_id: $client_detail_id,
            module: $module,
            category: $category,
            question_title: $question_title,
            answer_type: $answer_type,
        }){
            data{
                id
                attributes{
                    question_title
                }
            }
        }
    }
`;

// // // // ============================================================================================================================
export const createDefaultLovsDropDown = gql`
    mutation createDropDownOption(
        $title: String,
        $active: Boolean
    ){
        createDropDownOption(data:{
            title: $title,
            active: $active
        }){
            data{
                id
                attributes{
                    title
                }
            }
        }
    }
`;

export const createDesignFrontendInputName = gql`
    mutation createDesignFrontendInputName(
        $input_name: String,
    ){
        createDesignFrontendInputName(data:{
            input_name:   $input_name,
        }){
            data{
                id
                attributes{
                    input_name
                }
            }
        }
    }
`;

export const createQuestionList = gql`
    mutation createQuestionList(
        $question: String,
        $active: Boolean
    ){
        createQuestionList(data:{
            question: $question,
            active: $active
        }){
            data{
                id
                attributes{
                    question
                    active
                }
            }
        }
    }
`;

// // // // // // // ==========================================================================================================

export const createNewDocument = gql`
    mutation createAuditDocument(
        $audit_module: ID,
        $audit_category: ID,
        $audit_type: ID,
        $document_description: String,
        $audit_document_name: ID,
        $active: Boolean,
        $company_id: ID,
        $reminder: Boolean
    ){
        createAuditDocument(data:{
            audit_module: $audit_module,
            audit_category: $audit_category,
            audit_type: $audit_type,
            document_description: $document_description,
            audit_document_name: $audit_document_name,
            active: $active,
            company_id: $company_id,
            reminder: $reminder
        }){
            data{
                id
                attributes{
                    audit_module{
                        data{
                            id
                            attributes{
                                title
                                active
                            }
                        }
                    }
                    audit_document_name{
                        data{
                            id
                            attributes{
                                title
                                active
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const createAuditModule = gql`
    mutation createAuditModule(
        $title: String,
        $active: Boolean,
        $description: String,
        $company_id: ID
    ){
        createAuditModule(data:{
            title: $title,
            active: $active,
            description: $description,
            company_id: $company_id
        }){
            data{
                id
                attributes{
                    title
                    active
                }
            }
        }
    }
`;

export const createAuditCategory = gql`
    mutation createAuditCategory(
        $title: String,
        $active: Boolean,
        $description: String,
        $company_id: ID
    ){
        createAuditCategory(data:{
            title: $title,
            active: $active,
            description: $description,
            company_id: $company_id
        }){
            data{
                id
                attributes{
                    title
                    active
                }
            }
        }
    }
`;

export const createAuditType = gql`
    mutation createAuditType(
        $title: String,
        $active: Boolean,
        $description: String,
        $company_id: ID
    ){
        createAuditType(data:{
            title: $title,
            active: $active,
            description: $description,
            company_id: $company_id
        }){
            data{
                id
                attributes{
                    title
                    active
                }
            }
        }
    }
`;

export const createAuditDocumentName = gql`
    mutation createAuditDocumentName(
        $title: String,
        $active: Boolean,
        $description: String,
        $company_id: ID,
        $type: String,
    ){
        createAuditDocumentName(data:{
            title: $title,
            active: $active,
            description: $description,
            company_id: $company_id,
            type: $type
        }){
            data{
                id
                attributes{
                    title
                    active
                    description
                    type
                }
            }
        }
    }
`;

// /// /// // // // ==================================== Price List =================================================
export const createPriceList = gql`
    mutation createPriceList(
        $code: String,
        $service_name: String,
        $rate_type: ENUM_PRICELIST_RATE_TYPE,
        $rate: Long,
        $afternoon_rate: Long,
        $night_rate: Long,
        $saturday_rate: Long,
        $sunday_rate: Long,
        $public_holiday_rate: Long
    ){
        createPriceList(data:{
            code: $code,
            service_name: $service_name,
            Rate_Type: $rate_type,
            rate: $rate,
            afternoon_rate: $afternoon_rate,
            night_rate: $night_rate,
            saturday_rate: $saturday_rate,
            sunday_rate: $sunday_rate,
            public_holiday_rate: $public_holiday_rate
        }){
            data{
                id
                attributes{
                    service_name
                }
            }
        }
    }
`;

// // // // // // =================================== Organization =============================================
export const createOrganization = gql`
    mutation createOrgnization(
        $registration_number: String,
        $company_name: String,
        $email: String,
        $phone: String,
        $website_url: String,
        $abn: String,
        $description: String,
        $primary_invoice: String,
        $secondary_invoice: String,
        $primary_schedule_email: String,
        $secondary_schedule_email: String,
        $notes: String
    ){
        createOrgnization(data:{
            registration_number: $registration_number,
            company_name: $company_name,
            email: $email,
            phone: $phone,
            website_url: $website_url,
            abn: $abn,
            description: $description,
            primary_invoice: $primary_invoice,
            secondary_invoice: $secondary_invoice,
            primary_schedule_email: $primary_schedule_email,
            secondary_schedule_email: $secondary_schedule_email,
            notes: $notes
        }){
            data{
                id
                attributes{
                    company_name
                }
            }
        }
    }
`;

// // /// // =============================update data ====================================================

export const updateStaffDetail = gql`
    mutation updateStaffDetail($id: ID!, $data: StaffDetailInput!){
        updateStaffDetail(id:$id, data: $data){
            data{
                id
                attributes{
                    first_name
                    active
                    approved_status
                    last_name
                    ndis_clearance_number
                    email
                }
            }
        }
    }
`;

export const updateClientDetail = gql`
    mutation updateClientDetail($id: ID!, $data: ClientDetailInput!){
        updateClientDetail(id:$id, data: $data){
            data{
                id
                attributes{
                    first_name
                    active
                    approved_status
                }
            }
        }
    }
`;

// // // // // ===========================Service=================================================================

export const createServiceRequest = gql`
    mutation createServiceRequest(
        $client_detail_id: ID,
        $charge_band_detail_id: ID,
        $funding_source: String,
        $billable: String,
        $pay_travel_km: String
    ){
        createServiceRequest(data:{
            client_detail_id: $client_detail_id,
            charge_band_detail_id: $charge_band_detail_id,
            funding_source: $funding_source,
            billable: $billable,
            pay_travel_km: $pay_travel_km
        }){
            data{
                id
                attributes{
                    client_detail_id{
                        data{
                            id
                        }
                    }
                }
            }
        }
    }
`;

export const createServiceShift = gql`
    mutation createServiceShift(
        $shift_start: Time,
        $shift_end: Time,
        $visit_day_id: ID,
        $total_shift_hours: Float,
        $shift_start_flag: ENUM_SERVICESHIFT_SHIFT_START_FLAG,
        $shift_completed:Boolean,
        $shift_comments: String,
        $day_time_hours: Float,
        $evening_hours: Float,
        $night_hours: Float,
        $shift_end_flag: ENUM_SERVICESHIFT_SHIFT_END_FLAG,
  		$sleepover_hours: Float,
        $saturday_hours: Float,
        $sunday_hours: Float,
        $holiday_hours: Float,
        $shift_date: Date,
        $staff_detail_id: ID
    ){
        createServiceShift(data:{
            shift_start: $shift_start,
            shift_end: $shift_end,
            visit_day_id: $visit_day_id,
            total_shift_hours: $total_shift_hours,
            shift_start_flag: $shift_start_flag,
            shift_completed: $shift_completed,
            shift_comments: $shift_comments,
            day_time_hours: $day_time_hours,
            evening_hours: $evening_hours,
            night_hours: $night_hours,
            shift_end_flag: $shift_end_flag,
            sleepover_hours: $sleepover_hours,
            saturday_hours: $saturday_hours,
            sunday_hours: $sunday_hours,
            holiday_hours: $holiday_hours,
            shift_date: $shift_date,
            staff_detail_id: $staff_detail_id
        }){
            data{
                id
                attributes{
                    shift_start_flag
                    shift_end_flag
                    day_time_hours
                    evening_hours
                    night_hours
                    visit_day_id{
                        data{
                            id
                        }
                    }
                }
            }
        }
    }
`;

export const createVisitDay = gql`
    mutation createVisitDay(
        $recurring_type: String,
        $start_time: Time,
        $end_time: Time,
        $start_date: Date,
        $end_date: Date,
        $week_days: JSON,
        $selected_days:JSON,
        $x_days: String,
        $service_request_id: ID
    ){
        createVisitDay(data:{
            recurring_type: $recurring_type,
            start_time: $start_time,
            end_time: $end_time,
            start_date: $start_date,
            end_date: $end_date,
            week_days: $week_days,
            selected_days: $selected_days,
            x_days: $x_days,
            service_request_id: $service_request_id
        }){
            data{
                id
                attributes{
                    recurring_type
                }
            }
        }
    }
`;

export const createVisitShiftCheckList = gql`
    mutation createVisitShiftCheckList(
        $shift_title: String,
        $shift_comments: String,
        $client_detail_id: ID,
        $service_request_id: ID
    ){
        createVisitShiftCheckList(data:{
            shift_title: $shift_title,
            shift_comments: $shift_comments,
            client_detail_id: $client_detail_id,
            service_request_id: $service_request_id,
        }){
            data{
                id
            }
        }
    }
`;

export const updateReimbursement = gql`
    mutation updateReimbursement($id:ID!, $data: ReimbursementInput! ){
        updateReimbursement(id: $id, data: $data){
            data{
                id
                attributes{
                    approved_status
                    rejected_status
                }
            }
        }
    }
`;

export const updateKilometersClaim = gql`
    mutation updateKilometersClaim($id:ID!, $data: KilometersClaimInput! ){
        updateKilometersClaim(id: $id, data: $data){
            data{
                id
                attributes{
                    approved_status
                    rejected_status
                }
            }
        }
    }
`;

export const createServicePlan = gql`
    mutation createServicePlan(
        $staff_id: ID,
        $service_request_id: ID,
        $created_date: Date,
    ){
        createServicePlan(data:{
            staff_id: $staff_id,
            service_request_id: $service_request_id,
            created_date: $created_date
        }){
            data{
                id
            }
        }
    }
`;

export const updateServicePlan = gql`
    mutation updateServicePlan($id: ID!, $data: ServicePlanInput!){
        updateServicePlan(id: $id, data: $data){
            data{
                id
            }
        }
    }
`;

export const createChargeBandDetail = gql`
    mutation createChargeBandDetail(
        $charge_band_name: String,
        $charge_band_type: String,
        $ndis_price_list_id: ID,
        $charge_band_year: String
    ){
        createChargeBandDetail(data:{
            charge_band_name: $charge_band_name,
            charge_band_type: $charge_band_type,
            ndis_price_list_id: $ndis_price_list_id,
            charge_band_year: $charge_band_year,
        }){
            data{
                id
                attributes{
                    charge_band_name
                    ndis_price_list_id{
                      data{
                        attributes{
                          support_item_name,
                          WA
                        }
                      }
                    }
                }
            }
        }
    }
`;

export const createChargeBandRate = gql`
    mutation createChargeBandRate(
        $day_rate: Float,
        $evening_rate: Float,
        $sunday_rate: Float,
        $saturday_rate: Float,
        $public_holiday_rate: Float,
        $night_rate: Float,
        $charge_band_detail_id: ID,
    ){
        createChargeBandRate(data:{
            day_rate: $day_rate,
            evening_rate: $evening_rate,
            sunday_rate: $sunday_rate,
            saturday_rate: $saturday_rate,
            public_holiday_rate: $public_holiday_rate,
            night_rate: $night_rate,
            charge_band_detail_id: $charge_band_detail_id
        }){
            data{
                id
                attributes{
                    day_rate
                }
            }
        }
    }
`;

export const updateChargeBandRate = gql`
    mutation createChargeBandRate($id: ID!, $data: ChargeBandRateInput!){
        updateChargeBandRate(id: $id,data: $data){
            data{
                id
                attributes{
                    day_rate
                }
            }
        }
    }
`;

export const updateStaffHoursStatus = gql`
mutation createStaffAdjustHour($id: ID!, $data: StaffAdjustHourInput!){
    updateStaffAdjustHour(id: $id,data: $data){
        data{
            id
            attributes{
                status
            }
        }
    }
}
`;

export const updateInvoiceStatus = gql`
    mutation createInvoicing($id: ID!, $data: InvoicingInput!){
        updateInvoicing(id: $id,data: $data){
            data{
                id
                attributes{
                    claimed_status
                }
            }
        }
    }`;

// // /// // =======================================invoicing=========================================

export const createInvoicing = gql`
    mutation createInvoicing(
        $claim_reference: String,
        $quantity: String,
        $hours: String,
        $unit_price: String,
        $total_price: String,
        $gst_code: String,
        $authorised_by: String,
        $total_kilometers_claim: String,
        $total_invoice_amount: String,
        $registration_number: String,
        $client_detail_id: ID,
        $service_request_id: ID,
        $invoicing_start_date: Date,
        $invoicing_end_date: Date,
        $company_id: ID,
        $csv_generated: Boolean,
        $pdf_generated: Boolean,
        $invoice_genreated_reference: String
    ){
        createInvoicing(data:{
            claim_reference: $claim_reference,
            quantity: $quantity,
            hours: $hours,
            unit_price: $unit_price,
            total_price: $total_price,
            gst_code: $gst_code,
            authorised_by: $authorised_by,
            total_kilometers_claim: $total_kilometers_claim,
            total_invoice_amount: $total_invoice_amount,
            registration_number: $registration_number,
            client_detail_id: $client_detail_id,
            service_request_id: $service_request_id,
            invoicing_start_date: $invoicing_start_date,
            invoicing_end_date: $invoicing_end_date,
            company_id: $company_id,
            csv_generated: $csv_generated,
            pdf_generated: $pdf_generated,
            invoice_genreated_reference: $invoice_genreated_reference
        }){
            data{
            id
                attributes{
                    claim_reference
                }
            }
        }
    }
`;

export const createNewStaffPay = gql`
    mutation createStaffPayroll(
        $staff_detail_id: ID,
        $day_rate: String,
        $day_hours: String,
        $total_day_amount: String,
        $night_rate: String,
        $night_hours: String,
        $total_night_amount: String,
        $evening_hours: String,
        $evening_rate: String,
        $total_evening_amount: String,
        $saturday_rate: String,
        $saturday_hours: String,
        $total_saturday_amount: String,
        $sunday_rate: String,
        $sunday_hours: String,
        $total_sunday_amount: String,
        $holiday_rate: String,
        $holiday_hours: String,
        $total_holiday_amount: String,
        $kilometers_claim: String,
        $reimbursement: String,
        $bonus: String,
        $total_pay: String,
        $total_hours: String,
        $approved: String,
        $pay_start_date: Date,
        $pay_end_date: Date,
        $satff_pay_id: String
    ){
        createStaffPayroll(data:{
            staff_detail_id: $staff_detail_id,
            day_rate: $day_rate,
            day_hours: $day_hours,
            total_day_amount: $total_day_amount,
            night_rate: $night_rate,
            night_hours: $night_hours,
            total_night_amount: $total_night_amount,
            evening_hours: $evening_hours,
            evening_rate: $evening_rate,
            total_evening_amount: $total_evening_amount,
            saturday_rate: $saturday_rate,
            saturday_hours: $saturday_hours,
            total_saturday_amount: $total_saturday_amount,
            sunday_rate: $sunday_rate,
            sunday_hours: $sunday_hours,
            total_sunday_amount: $total_sunday_amount,
            holiday_rate: $holiday_rate,
            holiday_hours: $holiday_hours,
            total_holiday_amount: $total_holiday_amount,
            kilometers_claim: $kilometers_claim,
            reimbursement: $reimbursement,
            bonus: $bonus,
            total_pay: $total_pay,
            total_hours: $total_hours,
            approved: $approved,
            pay_start_date: $pay_start_date,
            pay_end_date: $pay_end_date,
            satff_pay_id: $satff_pay_id
        }){
            data{
                id
                attributes{
                    total_pay
                }
            }  
        }
    }
`;


// // /// // =======================================clientMutation=========================================

export const SendOnboardingLinkEmail = gql`
    mutation createGuardianFormEmailList(
        $form_url: String!,
        $email_recipient: String!
    ) {
        createGuardianFormEmailList(
            data: {
            form_url: $form_url,
            email_recipient: $email_recipient
            }
        ) {
            data {
                id
            }
        }
    }
`;